<template>
  <div class="country-filter" >
    <div class="country-filter-body">
      <div class="visa-type-box">
        <div
          class="visa-type-item"
          :class="{active: item === visaType}"
          v-for="item in visaTypeBefore"
          :key="item"
          @click="changeVisaType(item)"
        >
          <visa-type-text :visa-type="item"></visa-type-text>
        </div>

        <div class="visa-type-other" v-if="visaTypeLater.length" ref="visaTypeOther">
          <div class="other-value" :class="{active: isSelectVisaTypeLaterFive}">
            <div class="visa-type-text">
              <visa-type-text v-if="isSelectVisaTypeLaterFive" :visa-type="visaType"></visa-type-text>
              <span v-else>更多</span>
            </div>
            <img class="down-triangle blue-triangle" src="../../../assets/imgs/product-detail/icon-down-blue.png">
            <img class="down-triangle gray-triangle" src="../../../assets/imgs/product-detail/icon-down-gray.png">
          </div>

          <div class="other-visa-type-popup">
            <div
              class="other-visa-type-item"
              :class="{active: item === visaType}"
              v-for="item in visaTypeLater"
              :key="item"
              @click="changeVisaType(item)"
            >
              <visa-type-text :visa-type="item"></visa-type-text>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-entry-count">
        <div class="entry-count-list" v-if="productList.length">
          <div
            class="filter-item"
            :class="{active: item.value === entryCountType}"
            v-for="item in showFilterEntryCountList"
            :key="item.value"
            @click="changeProductFilter(item)"
          >{{ item.name }}</div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import VisaTypeText from './visa-type-text.vue';

export default {
  components: {
    VisaTypeText,
  },
  props: {
    countryInfo: Object,
    productList: {
      type: Array,
      default() {
        return [];
      },
    },
    entryCountType: Number,
    visaType: String,
  },
  data() {
    return {
      filterEntryCountList: [
        {
          name: '综合排序',
          value: 0,
        },
        {
          name: '单次入境',
          value: 1,
        },
        {
          name: '多次入境及其他',
          value: 2,
        },
      ],
      layout: {
        isFilterFixed: false,
      },
      visaTypeBeforeLength: 0,
    };
  },
  computed: {
    // 非推荐列表
    needFilterProductList() {
      return this.productList.filter(product => !product.is_recommended);
    },
    showFilterEntryCountList() {
      const someSingle = this.needFilterProductList.some(item => item.entry_count_unit === 0 && item.entry_count_n === 1);
      const someOther = this.needFilterProductList.some(item => item.entry_count_unit !== 0 || item.entry_count_n !== 1);
      return this.filterEntryCountList.map((item) => {
        let show = false;
        if (item.value === 0) {
          show = true;
        } else if (item.value === 1 && someSingle) {
          show = true;
        } else if (item.value === 2 && someOther) {
          show = true;
        }
        return {
          ...item,
          show,
        };
      }).filter(item => item.show);
    },

    // 签证类型前
    visaTypeBefore() {
      if (!this.countryInfo) return [];
      return this.countryInfo.visa_type_list.slice(0, this.visaTypeBeforeLength);
    },
    // 签证类型五个后
    visaTypeLater() {
      if (!this.countryInfo) return [];
      return this.countryInfo.visa_type_list.slice(this.visaTypeBeforeLength);
    },
    // 当前是否选中了其他类型的选项
    isSelectVisaTypeLaterFive() {
      return this.visaTypeLater.indexOf(this.visaType) > -1;
    },
  },
  watch: {
    'countryInfo.visa_type_list': function () {
      this.calculateVisaTypeBeforeLength();
    },
  },
  created() {
    this.calculateVisaTypeBeforeLength();
  },
  methods: {
   
    changeProductFilter(record) {
      this.$emit('update:entryCountType', record.value);
      this.sensorsFilter(record.name);
    },
    
    changeVisaType(visaType) {
      if (this.visaType === visaType) return;
      sensorsdata.track('Screening_Visa_Type', {
        country: this.countryInfo.country,
        visa_type: visaType,
      });
      this.$emit('update:visaType', visaType);
      this.sensorsFilter(visaType);
    },
    // 神策埋点，
    sensorsFilter(filterName) {
      // 神策埋点
      sensorsdata.track('Country_page_filtering', {
        country: this.countryInfo.country,
        platform_type: 'PC',
        click_content: filterName || '',
        click_tab: this.visaTypeName,
      });
    },

    calculateVisaTypeBeforeLength() {
      // 剩余留给前面类型的宽度，
      const containerWidth = 1120 - 60 - 100;
      if (!containerWidth) return;
      let usedWidth = 0;

      let visaTypeBeforeLength = this.countryInfo.visa_type_list.length;
      for (let index = 0; index < this.countryInfo.visa_type_list.length; index++) {
        const element = this.countryInfo.visa_type_list[index];
        const optionWidth = this.getTextWidth(element);
        if (usedWidth + optionWidth <= containerWidth) {
          usedWidth += optionWidth;
        } else {
          visaTypeBeforeLength = index;
          break;
        }
      }
      this.visaTypeBeforeLength = visaTypeBeforeLength;
    },
    getTextWidth(text) {
      // 创建一个临时元素计算文本宽度
      const el = document.createElement('div');
      el.setAttribute('style', 'font-size: 16px;position:absolute;left: -9999px;top:-9999px;');
      el.innerHTML = text;
      document.body.appendChild(el);
      // margin right 48
      const width = el.offsetWidth + 48;
      document.body.removeChild(el);
      return width;
    },
  },
};
</script>

<style lang="less" scoped>
.country-filter{
  position: relative;
  z-index: 5;
  .country-filter-body{
    border-radius: 2px;
    background: #fff;
    box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.06);
  }
  .visa-type-box{
    height: 60px; 
    padding: 0 30px;
    display: flex;
    align-items: center;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    
    .visa-type-item{
      flex-shrink: 0;
      display: flex;
      align-items: center;
      height: 100%;
      margin-right: 48px;
      color: #444444;
      font-size: 16px;
      position: relative;
      cursor: pointer;
      &:hover{
        color: #599FFF;
      }
      &.active{
        color: #599FFF;
        font-weight: 600;
        &::after{
          content: "";
          width: 30px;
          height: 4px;
          background: #599FFF;
          border-radius: 1px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

    }

    .visa-type-other{
      flex-shrink: 1;
      height: 100%;
      position: relative;
      max-width: 100px;
      .other-value{
        flex-grow: 1;
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;
        cursor: pointer;
        overflow: hidden;
        .visa-type-text{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex-shrink: 1;
          color: #444444;
          font-size: 16px;
        }
        .down-triangle {
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          margin-left: 4px;
          &.blue-triangle {
            display: none;
          }
        }
        &.active{
          &::after{
            content: "";
            width: 30px;
            height: 4px;
            background: #599FFF;
            border-radius: 1px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          .visa-type-text{
            color: #599FFF;
            font-weight: 600;
          }
          .down-triangle {
            &.blue-triangle {
              display: flex;
            }
            &.gray-triangle {
              display: none;
            }
          }
        }
      }

      &:hover{
        .other-visa-type-popup{
          display: block;
        }
      }
    }

    .other-visa-type-popup{
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-top: -8px;
      z-index: 10;
      display: none;
      background: #FFFFFF;
      box-shadow: 0px 8px 12px 0px rgba(47,51,61,0.06);
      border: 1px solid #E9EEF2;
      padding: 20px;
      &::after{
        content: "";
        border-width: 8px;
        border-color: transparent transparent #fff transparent;
        border-style: solid;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        margin-bottom: -1px;
      }
      &::before{
        content: "";
        border-width: 8px;
        border-color: transparent transparent #E9EEF2 transparent;
        border-style: solid;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9;
      }
      .other-visa-type-item{
        cursor: pointer;
        white-space: nowrap;
        color: #444444;
        font-size: 16px;
        margin-bottom: 20px;
        &:last-child{
          margin-bottom: 0;
        }
        &:hover{
          color: #599FFF;
        }
        &.active{
          color: #599FFF;
          font-weight: 600;
        }
      }
    }
  }
  .filter-entry-count{
    height: 40px;
    padding: 0 30px;
    .entry-count-list{
      display: flex;
      align-items: center;
      height: 40px;
    }
    .filter-item{
      position: relative;
      color: #6F6F6F;
      font-size: 14px;
      cursor: pointer;
      margin-left: 48px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child{
        &::after{
          display: none;
        }
      }
      &:hover{
        color: #3FA2F5;
      }
      &.active{
        color: #3FA2F5;
        font-weight: 600;
      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/country/components/country-filter.vue